import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '@/modules/shared/components/ui/accordion'
import { Separator } from '@/modules/shared/components/ui/separator'
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
} from '@/modules/shared/components/ui/sheet'
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from '@/modules/shared/components/ui/tabs'
import { converterUnidadeMedida } from '@/modules/shared/utils/converter-medida'
import { converterPeso } from '@/modules/shared/utils/converter-peso'

import { ProductDetailsFormComponent } from '../components/product-details-form.component'
import { ProductDetailsOrderHistoryComponent } from '../components/product-details-history.component'
import type { useProductDetailsHook } from '../hooks/use-product-details.hook'
import { useProductStore } from '../stores/product.store'

export type ProductDetailsInterface = ReturnType<typeof useProductDetailsHook>

export function ProductDetailsOrderInterface(props: ProductDetailsInterface) {
	const { productDetails, modalProps } = props

	const { defaultTabsProductDetails } = useProductStore()

	return (
		<Sheet
			open={modalProps.isOpenDetails}
			onOpenChange={modalProps.onCloseDetails}
		>
			<SheetContent className="h-screen w-full">
				<SheetHeader>
					<SheetTitle>Detalhes do Produto</SheetTitle>
				</SheetHeader>

				<div className="flex flex-col w-full">
					<div className="flex flex-col w-full my-4 items-center">
						<div className="w-28 h-28">
							<img
								src={productDetails.productImage || '/sem-foto.jpeg'}
								alt="Imagem do produto"
								className="object-contain w-full h-full"
							/>
						</div>

						<p className="text-sm text-center">
							{productDetails.productDescription}
						</p>
						<Accordion type="single" collapsible className="w-full">
							<AccordionItem value="1">
								<AccordionTrigger>
									<p className="text-sm">Mais Informações</p>
								</AccordionTrigger>
								<AccordionContent>
									<div>
										<div className="text-xs flex w-full justify-between mt-2 self-start space-x-3">
											<div className="flex flex-1  flex-col">
												<p className="font-medium">Qtd. Embalagem </p>
												<p>{productDetails.qtdeEmbalagem}</p>
											</div>
											<div className="flex flex-1 flex-col">
												<p className="font-medium">Embalagem Master </p>
												<p>
													{productDetails.qtdEmbMaster
														? productDetails.qtdeEmbalagem
														: 'N/A'}
												</p>
											</div>
											<div className="flex flex-1 flex-col">
												<p className="font-medium">Peso Líquido </p>
												<p>
													{productDetails.pesoLiquido
														? converterPeso(productDetails.pesoLiquido)
														: 'N/A'}
												</p>
											</div>
											<div className="flex flex-1 flex-col">
												<p className="font-medium">Peso Bruto </p>
												<p>
													{productDetails.pesoBruto
														? converterPeso(productDetails.pesoBruto)
														: 'N/A'}
												</p>
											</div>
										</div>
										<Separator className="my-3" />
										<div className="text-xs flex w-full justify-between mt-2 self-start space-x-4">
											<div className="flex flex-1 flex-col ">
												<p className="font-medium">Altura </p>
												<p>
													{productDetails.altura
														? converterUnidadeMedida(productDetails.altura)
														: 'N/A'}
												</p>
											</div>
											<div className="flex flex-1 flex-col ">
												<p className="font-medium">Largura </p>
												<p>
													{productDetails.largura
														? converterUnidadeMedida(productDetails.largura)
														: 'N/A'}
												</p>
											</div>
											<div className="flex flex-1 flex-col ">
												<p className="font-medium">Comprimento </p>
												<p>
													{productDetails.comprimento
														? converterUnidadeMedida(productDetails.comprimento)
														: 'N/A'}
												</p>
											</div>
											<div className="flex flex-1 flex-col">
												<p className="font-medium">Cubagem </p>
												<p>
													{productDetails.cubagem
														? `${productDetails.cubagem} m³`
														: 'N/A'}
												</p>
											</div>

										</div>
										<Separator className="my-3" />
										<div className="text-xs flex w-full justify-between mt-2 self-start space-x-4">
											<div className="flex flex-1 flex-col ">
												<p className="font-medium">Porc. Comissão </p>
												<p>
													{productDetails?.porcComissao}
												</p>
											</div>

										</div>
									</div>
								</AccordionContent>
							</AccordionItem>
						</Accordion>
					</div>

					<Tabs defaultValue={defaultTabsProductDetails}>
						<TabsList className="w-full">
							<TabsTrigger className="flex-1" value="dados">
								Dados
							</TabsTrigger>
							<TabsTrigger className="flex-1" value="historico">
								Histórico
							</TabsTrigger>
						</TabsList>
						<TabsContent value="dados">
							<ProductDetailsFormComponent />
						</TabsContent>

						<TabsContent value="historico">
							<ProductDetailsOrderHistoryComponent />
						</TabsContent>
					</Tabs>
				</div>
			</SheetContent>
		</Sheet>
	)
}
